import { render, staticRenderFns } from "./song.vue?vue&type=template&id=688cee3e&"
import script from "./song.vue?vue&type=script&lang=js&"
export * from "./song.vue?vue&type=script&lang=js&"
import style0 from "./song.vue?vue&type=style&index=0&id=688cee3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports